import { fmtDM, fmtDate } from '../dates.js';
import { myName } from '../team/team.js';
import { I18N, t } from '../i18n/index.js';
import { copyRich, copyText, fillTpl, mailtoLink, payDetails, tpl, waLink } from '../messaging.js';
import { groupLabel, stu } from '../model.js';
import { S, persist } from '../state.js';
import { $, IC, avatarHtml, closeSheet, esc, render, sheet, toast } from '../ui.js';
import { bindPicsField, picsField } from './pics.js';
import { CLOUD, loggedIn, sbRefresh, sbUrl } from '../cloud/api.js';
import { cloudPush } from '../cloud/sync.js';

export function recapVars(ses,sum){
  return{
    student:stu(ses.studentId).first,date:fmtDate(ses.date),time:ses.time,duration:ses.dur,
    topics:(sum.topics||[]).map(x=>'• '+x).join('\n')||'—',
    vocab:(sum.vocab||[]).map(v=>'• '+v.f+(v.t?' — '+v.t:'')).join('\n')||'—',
    grammar:sum.grammar||'—',homework:sum.homework||'—',next:sum.next||'—',
    teacher:myName()||'—'
  };
}
/* drop headings whose content is empty ("—"), then squeeze the blank lines left behind */
export function tidyRecap(text){
  return String(text||'').replace(/\r/g,'').replace(/(^|\n)[^\n]+\n[ \t]*—[ \t]*(?=\n|$)/g,'$1').replace(/\n{3,}/g,'\n\n').trim();
}
export function recapPlain(ses,lang){const tp=tpl('summary',lang);return tidyRecap(fillTpl(tp.b,recapVars(ses,ses.summary||{})))}
export function recapHTML(ses,lang){
  const s=stu(ses.studentId),sum=ses.summary||{};
  const sec=(title,body)=>body&&body!=='—'?'<p style="margin:14px 0 4px"><b style="font-size:12px;letter-spacing:.08em;color:#2242C8">'+esc(title.toUpperCase())+'</b></p>'+body:'';
  const li=arr=>'<ul style="margin:2px 0 0 18px;padding:0">'+arr.map(x=>'<li style="margin:2px 0">'+x+'</li>').join('')+'</ul>';
  const L=I18N[lang]||I18N.en;
  let h='<div style="font-family:Arial,Helvetica,sans-serif;font-size:14px;color:#1B1C22;line-height:1.5">';
  h+='<p>'+esc(fillTpl((lang==='de'?'Hallo {s},':lang==='fr'?'Bonjour {s},':'Hi {s},').replace('{s}',s.first),{}))+'</p>';
  if(sum.topics&&sum.topics.length)h+=sec(L['sum.topics'],li(sum.topics.map(esc)));
  if(sum.vocab&&sum.vocab.length)h+=sec(L['sum.vocab'],li(sum.vocab.map(v=>'<b>'+esc(v.f)+'</b>'+(v.t?' — '+esc(v.t):''))));
  if(sum.grammar)h+=sec(L['sum.grammar'],'<p style="margin:2px 0">'+esc(sum.grammar).replace(/\n/g,'<br>')+'</p>');
  if(sum.homework)h+=sec(L['sum.homework'],'<p style="margin:2px 0">'+esc(sum.homework).replace(/\n/g,'<br>')+'</p>');
  if(sum.next)h+=sec(L['sum.next'],'<p style="margin:2px 0">'+esc(sum.next).replace(/\n/g,'<br>')+'</p>');
  if(sum.note)h+='<p style="margin:14px 0 0;color:#565863">'+esc(sum.note).replace(/\n/g,'<br>')+'</p>';
  h+='<p style="margin-top:18px">'+({de:'Bis bald',en:'See you soon',fr:'À bientôt'}[lang]||'Bis bald')+',<br>'+esc(myName()||'')+'</p></div>';
  return h;
}
export function openRecap(sesId,groupIds){
  const ses=S.sessions.find(x=>x.id===sesId);if(!ses)return;
  /* group lesson: one recap, copied to every student of the group (each keeps their own personal note) */
  const group=(groupIds||[]).map(id=>S.sessions.find(x=>x.id===id)).filter(x=>x&&x!==ses);
  const isGroup=group.length>0;
  const s=stu(ses.studentId);
  const sum=ses.summary||{topics:[],vocab:[],grammar:'',homework:'',next:'',note:''};
  const vrows=()=>sum.vocab.map((v,i)=>`<div class="vocabrow"><input class="input" data-vf="${i}" value="${esc(v.f)}" placeholder="${t('sum.term')}"><input class="input" data-vt="${i}" value="${esc(v.t)}" placeholder="${t('sum.trans')}"><button class="iconbtn" data-vx="${i}">${IC.x}</button></div>`).join('');
  const b=sheet(`<div class="sheethead"><h2>${isGroup?t('grp.recapFor',{g:esc(groupLabel([ses,...group])),date:fmtDM(ses.date)}):t('sum.for',{name:esc(s.first),date:fmtDM(ses.date)})}</h2><button class="iconbtn" data-a="x">${IC.x}</button></div>
  <div class="sheetbody">
    <div class="field"><label>${t('sum.topics')}</label><textarea class="textarea" id="rc-topics" placeholder="${t('sum.topicsPh')}">${esc(sum.topics.join('\n'))}</textarea></div>
    <div class="field"><label>${t('sum.vocab')}</label><div id="rc-vocab">${vrows()}</div><button class="btn small" data-a="addv">${IC.plus} ${t('sum.addV')}</button></div>
    <div class="formrow">
      <div class="field"><label>${t('sum.grammar')}</label><textarea class="textarea" id="rc-gram" style="min-height:60px">${esc(sum.grammar)}</textarea></div>
      <div class="field"><label>${t('sum.homework')}</label><textarea class="textarea" id="rc-hw" style="min-height:60px">${esc(sum.homework)}</textarea></div>
    </div>
    <div class="field"><label>${t('sum.next')}</label><input class="input" id="rc-next" value="${esc(sum.next)}"></div>
    ${isGroup?`<p class="hint mb8">${t('grp.recapHint',{n:group.length+1})}</p>`:`<div class="field"><label>${t('sum.free')} <span class="tiny">(${t('c.optional')})</span></label><input class="input" id="rc-note" value="${esc(sum.note||'')}"></div>`}
    ${picsField()}
  </div>
  <div class="sheetfoot"><div class="left"><button class="btn" data-a="save">${t('c.save')}</button></div>
  <button class="btn primary" data-a="send">${IC.mail} ${t('sum.channels')}</button></div>`,'wide');
  const q=x=>b.querySelector(x);
  const collect=()=>{
    sum.topics=q('#rc-topics').value.split('\n').map(x=>x.trim()).filter(Boolean);
    sum.vocab=sum.vocab.map((v,i)=>({f:q('[data-vf="'+i+'"]')?q('[data-vf="'+i+'"]').value.trim():v.f,t:q('[data-vt="'+i+'"]')?q('[data-vt="'+i+'"]').value.trim():v.t})).filter(v=>v.f);
    sum.grammar=q('#rc-gram').value.trim();sum.homework=q('#rc-hw').value.trim();sum.next=q('#rc-next').value.trim();if(q('#rc-note'))sum.note=q('#rc-note').value.trim();
    ses.summary=sum;
    for(const g of group){const own=(g.summary&&g.summary.note)||'';g.summary={...JSON.parse(JSON.stringify(sum)),note:own}}
    persist();
  };
  const redrawV=()=>{collect();q('#rc-vocab').innerHTML=vrows();bindV()};
  const bindV=()=>{q('#rc-vocab').querySelectorAll('[data-vx]').forEach(btn=>btn.onclick=()=>{collect();sum.vocab.splice(+btn.dataset.vx,1);q('#rc-vocab').innerHTML=vrows();bindV()})};
  bindV();
  bindPicsField(b,ses);
  q('[data-a=x]').onclick=()=>{collect();closeSheet(b)};
  q('[data-a=addv]').onclick=()=>{collect();sum.vocab.push({f:'',t:''});q('#rc-vocab').innerHTML=vrows();bindV();const last=q('#rc-vocab').querySelector('[data-vf="'+(sum.vocab.length-1)+'"]');if(last)last.focus()};
  q('[data-a=save]').onclick=()=>{collect();toast(t('sum.saved'));render()};
  if(isGroup){q('[data-a=send]').onclick=()=>{
    collect();closeSheet(b);render();
    const all=[ses,...group];
    const c=sheet(`<div class="sheethead"><h2>${t('grp.sendTo')}</h2><button class="iconbtn" data-a="x">${IC.x}</button></div>
      <div class="sheetbody"><p class="hint mb8">${t('grp.sendHint')}</p>${all.map((x,i)=>{const st=stu(x.studentId)||{first:'?'};return `<button type="button" class="listrow click grprow" data-i="${i}">${avatarHtml(st)}<span class="grow"><span class="title">${esc(st.first+' '+(st.last||''))}</span></span>${IC.right}</button>`}).join('')}</div>`);
    c.querySelector('[data-a=x]').onclick=()=>closeSheet(c);
    c.querySelectorAll('[data-i]').forEach(r=>r.onclick=()=>{closeSheet(c);openRecap(all[+r.dataset.i].id)});
  }}else q('[data-a=send]').onclick=()=>{
    collect();
    const lang=s.contactLang||S.settings.lang;
    const tp=tpl('summary',lang);const vars=recapVars(ses,sum);
    const subject=fillTpl(tp.s,vars),body=tidyRecap(fillTpl(tp.b,vars));
    const html=recapHTML(ses,lang);
    channelSheet(s,subject,body,html,()=>{printRecap(ses,lang)},{ses,lang});
  };
}
export function printRecap(ses,lang){
  const s=stu(ses.studentId);
  $('#printroot').innerHTML='<div class="invpaper"><h2>'+esc(S.settings.teacher||S.settings.biz||t('sum.title'))+'</h2><p style="color:#8B8D99;font-size:12px;margin-top:2px">'+esc(t('sum.title'))+' · '+esc(s.first+' '+(s.last||''))+' · '+esc(fmtDate(ses.date))+'</p><div style="margin-top:16px">'+recapHTML(ses,lang)+'</div></div>';
  window.print();
}
/* channel chooser: wa / mailto / copy rich / copy text / print */
export function channelSheet(s,subject,body,html,onPrint,plume){
  const pm=plume&&loggedIn()?plumeMailBox(s,plume.ses):'';
  const b=sheet(`<div class="sheethead"><h2>${t('sum.channels')}</h2><button class="iconbtn" data-a="x">${IC.x}</button></div>
  <div class="sheetbody">
    ${pm?pm+'<div class="pm-or">'+t('rm.or')+'</div>':''}
    <div class="row mb" style="gap:8px">
      <button class="btn${pm?'':' primary'}" data-a="wa">${IC.wa} ${t('sum.wa')}</button>
      <button class="btn" data-a="mail">${IC.mail} ${t('sum.mailto')}</button>
    </div>
    <div class="row mb" style="gap:8px">
      ${html?'<button class="btn" data-a="rich">'+IC.copy+' '+t('sum.copyRich')+'</button>':''}
      <button class="btn" data-a="txt">${IC.copy} ${t('sum.copyTxt')}</button>
      ${onPrint?'<button class="btn" data-a="print">'+IC.print+' '+t('sum.print')+'</button>':''}
    </div>
    <div class="copyarea">${esc(subject)}\n\n${esc(body)}</div>
  </div>`);
  const q=x=>b.querySelector(x);
  q('[data-a=x]').onclick=()=>closeSheet(b);
  q('[data-a=wa]').onclick=()=>{if(!s.phone){toast(t('wa.none',{name:s.first}));return}window.open(waLink(s.phone,subject+'\n\n'+body),'_blank')};
  q('[data-a=mail]').onclick=()=>{if(!s.email){toast(t('mail.none',{name:s.first}));return}location.href=mailtoLink(s.email,subject,body)};
  if(q('[data-a=rich]'))q('[data-a=rich]').onclick=()=>copyRich(html,body);
  q('[data-a=txt]').onclick=()=>copyText(subject+'\n\n'+body);
  if(q('[data-a=print]'))q('[data-a=print]').onclick=onPrint;
  if(pm)bindPlumeMail(b,s,plume);
}
/* ---------- recap as a designed Plume email (sent by the notify function, replies go to the teacher) ---------- */
function mailTargets(s){
  const ok=x=>/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(String(x||'').trim());
  const out=[];
  if(ok(s.email))out.push({who:s.first,addr:s.email.trim(),on:true});
  for(const e of [s.parentEmail,s.parentEmail2])if(ok(e)&&!out.some(o=>o.addr.toLowerCase()===e.trim().toLowerCase()))out.push({who:t('rm.parents'),addr:e.trim(),on:!ok(s.email)});
  return out;
}
function plumeMailBox(s,ses){
  const tg=mailTargets(s),np=(ses.pics||[]).length;
  return `<div class="pmail"><div class="pm-head"><span class="planic">${IC.mail}</span><div class="grow"><b>${t('rm.title')}</b><small>${t('rm.sub')}</small></div></div>
    ${tg.length?`<div class="pm-to">${tg.map((x,i)=>`<label class="check"><input type="checkbox" data-pmto="${i}" ${x.on?'checked':''}> <span><b>${esc(x.who)}</b> <span class="tiny">${esc(x.addr)}</span></span></label>`).join('')}
      ${np?`<label class="check"><input type="checkbox" id="pm-pics" checked> <span>${t('rm.pics',{n:np})}</span></label>`:''}</div>
      <button class="btn primary pm-send" data-a="pmsend">${IC.mail} ${t('rm.send')}</button>`
    :`<p class="hint">${t('rm.none',{name:esc(s.first)})}</p><button class="btn small" data-a="pmedit">${IC.edit} ${t('rm.addMail')}</button>`}</div>`;
}
async function pushedNow(){
  /* the lesson has to be in the cloud first: wait for the start-up sync and any running save (max ~12 s) */
  for(let i=0;i<48&&(!CLOUD.org||CLOUD.pushing||CLOUD.dirty);i++){
    if(CLOUD.org&&!CLOUD.pushing&&CLOUD.dirty)await cloudPush();
    if(!CLOUD.org||CLOUD.pushing||CLOUD.dirty)await new Promise(r=>setTimeout(r,250));
  }
  if(!CLOUD.org||CLOUD.dirty)throw new Error('unsaved');
}
function bindPlumeMail(b,s,{ses,lang}){
  const tg=mailTargets(s);
  const ed=b.querySelector('[data-a=pmedit]');
  if(ed)ed.onclick=()=>{closeSheet(b);import('./students.js').then(m=>m.openStudentEditor(s.id))};
  const btn=b.querySelector('[data-a=pmsend]');if(!btn)return;
  btn.onclick=async()=>{
    const to=tg.filter((x,i)=>b.querySelector('[data-pmto="'+i+'"]').checked).map(x=>x.addr);
    if(!to.length){toast(t('rm.pick'));return}
    btn.disabled=true;const old=btn.innerHTML;btn.innerHTML='<span class="spin sm"></span> '+t('rm.sending');
    try{
      await pushedNow();
      if(Date.now()>CLOUD.auth.exp)await sbRefresh();
      const r=await fetch(sbUrl('/functions/v1/notify/recap'),{method:'POST',headers:{apikey:CLOUD.cfg.key,Authorization:'Bearer '+CLOUD.auth.at,'Content-Type':'application/json'},
        body:JSON.stringify({lesson:ses.id,to,lang,pics:!!(b.querySelector('#pm-pics')&&b.querySelector('#pm-pics').checked),teacher:myName()||''})});
      const d=await r.json().catch(()=>({}));
      if(!r.ok)throw new Error(r.status===404&&!d.error?'old':d.error||('HTTP '+r.status));
      ses.recapSent={at:new Date().toISOString(),to};persist();
      closeSheet(b);toast(t('rm.sent',{to:to.join(', ')}));render();
    }catch(e){
      console.error('recap mail',e);const m=String(e&&e.message||e);
      toast(m==='old'?t('rm.old'):m==='email_off'?t('rm.off'):m==='unsaved'?t('rm.unsaved'):t('rm.err'));
      btn.disabled=false;btn.innerHTML=old;
    }
  };
}
export function sendFlow(type,s,extra){
  const lang=s.contactLang||S.settings.lang;
  const tp=tpl(type,lang);
  const vars={student:s.first,teacher:myName()||'—',paydetails:payDetails(),...extra};
  channelSheet(s,fillTpl(tp.s,vars),fillTpl(tp.b,vars),null,null);
}

/* ================= TIMER ================= */
